import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

//components
import ChangePassword from 'components/ChangePassword';

//styles
import {ChangePasswordView, ChangePasswordWrapper} from './styles';

@inject('store')
@observer
class ChangePasswordViewComponent extends Component {
  render() {
    const {isMobile} = this.props;

    return (
      <ChangePasswordView>
        <ChangePasswordWrapper>
          <ChangePassword isMobile={isMobile} />
        </ChangePasswordWrapper>
      </ChangePasswordView>
    );
  }
}

export default ChangePasswordViewComponent;
